// src/pages/staff/ShiftDetails.js
import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useParams, Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { format } from "date-fns";
import { MapContainer, TileLayer, Marker, Polyline, Popup } from "react-leaflet";
import L from "leaflet";



export default function ShiftDetails() {
  const { shiftId } = useParams();
  const [shift, setShift] = useState(null);
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const clientTasks = client?.toDoList || [];
  const [showFullReport, setShowFullReport] = useState(false);

  

// Icons (same as your YourNextShift.js)
const inIcon = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const outIcon = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});




// After: const [shift, setShift] = useState(null);

const shiftCompleted = (() => {
  if (!shift?.date || !shift?.endTime) return false;

  const now = new Date();
  const shiftEndTime = new Date(shift.date);

  const [endHour, endMin] = shift.endTime.split(":").map(Number);
  shiftEndTime.setHours(endHour || 0);
  shiftEndTime.setMinutes(endMin || 0);

  return now > shiftEndTime;
})();

  useEffect(() => {
    const load = async () => {
      const shiftSnap = await getDoc(doc(db, "shifts", shiftId));
      if (!shiftSnap.exists()) {
        setLoading(false);
        return;
      }

      const sData = shiftSnap.data();
      setShift(sData);

      if (sData.clientId) {
        const clientSnap = await getDoc(doc(db, "clients", sData.clientId));
        if (clientSnap.exists()) {
          setClient(clientSnap.data());
        }
      }

      setLoading(false);
    };

    load();
  }, [shiftId]);

  if (loading)
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-300 bg-gray-700/80">
        Loading shift details...
      </div>
    );

  if (!shift)
    return (
      <div className="p-6 text-center text-red-500">
        Shift not found.
      </div>
    );




const clockIn = shift.clockInLocation;   // {lat, lng}
const clockOut = shift.clockOutLocation; // {lat, lng}
const polyline = shift.routePolyline;    // array of LatLngs
const hasMap = clockIn || clockOut;






  const formatDate = (dateVal) => {
    try {
      return format(new Date(dateVal), "EEE, dd MMM yyyy");
    } catch {
      return dateVal || "N/A";
    }
  };




const formatTime = (ts) => {
  if (!ts) return "—";
  try {
    const date = ts.toDate ? ts.toDate() : new Date(ts.seconds * 1000);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  } catch (e) {
    return "—";
  }
};


const formatDateOnly = (ts) => {
  if (!ts) return "—";
  try {
    const date = ts.toDate ? ts.toDate() : new Date(ts.seconds * 1000);
    return date.toLocaleDateString([], { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "—";
  }
};




  const getDirections = () => {
    if (!shift.clientLocation) return;
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${shift.clientLocation.lat},${shift.clientLocation.lng}`
    );
  };

  return (
    <div className="p-6 pt-3 min-h-screen bg-gray-700/80 text-gray-100">
      <h1
        style={{
          textAlign: "center",
          color: "gray",
          backgroundColor: "white",
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          width: "fit-content",
          margin: "10px auto 0 auto",
          fontSize: "16px",
          fontWeight: "500",
          padding: "14px 24px",
          borderRadius: "20px",
        }}
      >
        Shift Details
      </h1>

      {/* ---------------- Main Shift Card ---------------- */}
      <div
        style={{
          maxWidth: "900px",
          margin: "20px auto 0 auto",
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "24px",
          color: "#1f2937",
          boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
        }}
      >
        {/* Client Name */}
        <h2 style={{ fontSize: "17px", fontWeight: "600", marginBottom: "6px" }}>
          {shift.clientName || "Client"}
        </h2>


{/* Client Address */}
        {client?.address && (
          <p style={{ fontSize: "13px", color: "#6b7280", marginTop: "8px" }}>
            📍 {client.address}
          </p>
        )}
        {/* Date + Time */}
        <p style={{ fontSize: "14px", color: "#6b7280" }}>
          
        </p>

        {/* Status */}
        <div
          style={{
            marginTop: "10px",
            width: "fit-content",
            padding: "6px 12px",
            borderRadius: "9999px",
            fontSize: "11px",
            fontWeight: "600",
            backgroundColor:
              shift.status === "Checked In"
                ? "#dcfce7"
                : shift.status === "Assigned"
                ? "#fef9c3"
                : "#e5e7eb",
            color:
              shift.status === "Checked In"
                ? "#15803d"
                : shift.status === "Assigned"
                ? "#a16207"
                : "#374151",
          }}
        >
          {shift.status || "Pending"}
        </div>
		
		
		<div className="px-5 mt-5">

  
{/* Modern Date/Time Card - Inline Styling */}
<div
  style={{
  background: "linear-gradient(to right, #eef6ff, #dceaff)",
  padding: "16px",
  borderRadius: "20px",
  border: "1px solid #bcd4ff",
  marginBottom: "16px",
  
}}

>
  {/* Date Row */}
  <p
    style={{
      fontSize: "18px",
      fontWeight: "600",
      color: "#1e3a8a",
      marginBottom: "12px",
	  
    }}
  >
    {format(new Date(shift.date), "EEE, dd MMM yyyy")}
  </p>

  {/* Two Column Grid */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "16px",
    }}
  >
    {/* Start Time Card */}
    <div
      style={{
        background: "rgba(255,255,255,0.6)",
        padding: "12px 16px",
        borderRadius: "30px",
        border: "1px solid #bcd4ff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
		display: "flex",
  flexDirection: "column",
  alignItems: "center"
      }}
    >
      <p
        style={{
          fontSize: "12px",
          color: "#2563eb",
          fontWeight: "500",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          margin: 0,
        }}
      >
        ⏱ Start
      </p>

      <p
        style={{
          fontSize: "20px",
          fontWeight: "600",
          color: "#1e3a8a",
          marginTop: "4px",
          marginBottom: 0,
        }}
      >
        {shift.startTime}
      </p>
    </div>

    {/* End Time Card */}
    <div
      style={{
        background: "rgba(255,255,255,0.6)",
        padding: "12px 16px",
        borderRadius: "30px",
        border: "1px solid #bcd4ff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
		
		display: "flex",
  flexDirection: "column",
  alignItems: "center"
      }}
    >
      <p
        style={{
          fontSize: "12px",
          color: "#2563eb",
          fontWeight: "500",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          margin: 0,
        }}
      >
        🕒 End
      </p>

      <p
        style={{
          fontSize: "20px",
          fontWeight: "600",
          color: "#1e3a8a",
          marginTop: "4px",
          marginBottom: 0,
        }}
      >
        {shift.endTime}
      </p>
    </div>
  </div>
</div>


 

</div>
	








	
		

        {/* Notes / rate / hours */}
        <div
          style={{
            color: "#4b5563",
            fontSize: "14px",
            marginTop: "16px",
            lineHeight: "1.5",
          }}
        >
          {shift.notes && <p>📝 {shift.notes}</p>}
          {shift.rate && <p>💷 Rate: £{shift.rate}/hr</p>}
          {shift.totalHours && <p>⏱️ Total Hours: {shift.totalHours}</p>}
        </div>

        
{/* REAL TIME CARD */}
<div
  style={{
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: "14px",
    padding: "16px",
    marginTop: "16px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  }}
>
  <h4
    style={{
      margin: 0,
      marginBottom: "10px",
      fontSize: "14px",
      fontWeight: "600",
      color: "#334155",
    }}
  >
    Real Time
  </h4>

  {/* Checked In */}
<p
  style={{
    margin: "0 0 6px 0",
    fontSize: "14px",
    color: "#1d4ed8", // blue
    fontWeight: "500",
  }}
>
  <strong style={{ color: "#1e40af" }}>Checked In:</strong>{" "}
  {formatDateOnly(shift.checkInTime)} at {formatTime(shift.checkInTime)}
</p>

{/* Checked Out */}
<p
  style={{
    margin: "0 0 10px 0",
    fontSize: "14px",
    color: "#b91c1c", // red
    fontWeight: "500",
  }}
>
  <strong style={{ color: "#991b1b" }}>Checked Out:</strong>{" "}
  {formatDateOnly(shift.checkOutTime)} at {formatTime(shift.checkOutTime)}
</p>

{/* Staff Name */}
<p
  style={{
    margin: "0 0 6px 0",
    fontSize: "13px",
    color: "#475569",
    fontStyle: "italic",
  }}
>
  Staff: <strong>{shift.staffName || "N/A"}</strong>
</p>



  {/* Map */}
  {hasMap && (
    <div
      style={{
        height: "250px",
        width: "100%",
        marginTop: "12px",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <MapContainer
        center={[
          clockIn?.lat || clockOut?.lat || 51.505,
          clockIn?.lng || clockOut?.lng || -0.09,
        ]}
        zoom={13}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {clockIn && (
          <Marker position={[clockIn.lat, clockIn.lng]} icon={inIcon}>
            <Popup>Clock In 📍</Popup>
          </Marker>
        )}

        {clockOut && (
          <Marker position={[clockOut.lat, clockOut.lng]} icon={outIcon}>
            <Popup>Clock Out 📍</Popup>
          </Marker>
        )}

        {polyline && <Polyline positions={polyline} color="blue" />}
      </MapContainer>
    </div>
  )}
</div>

		
		
		

		
		
		
	{/* ──────────────── PARAGRAPH STYLE REPORT WITH INITIALS ──────────────── */}
{(shift.reportReady || shift.staffNotes || shift.tasksCompleted) && clientTasks && (
  <div
    style={{
      marginTop: "24px",
      background: "white",
      padding: "24px",
      borderRadius: "16px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    }}
  >
    <h3
      style={{
        fontSize: "18px",
        fontWeight: "700",
        color: "#334155",
        marginBottom: "16px",
      }}
    >
      Visit Report
    </h3>

    {(() => {
      const completed = clientTasks
        .filter(t => shift.tasksCompleted?.[t.id])
        .map(t => t.text);

      const pending = clientTasks
        .filter(t => !shift.tasksCompleted?.[t.id])
        .map(t => t.text);

      const completedSentence = completed.length
        ? completed.join(", ")
        : "no tasks were marked as completed";

      const pendingSentence = pending.length
        ? pending.join(", ")
        : "there were no pending tasks";

      const dateStr = format(new Date(shift.date), "EEEE, dd MMM yyyy");

      // STAFF INITIALS
      const staffInitials = (shift.staffName || "")
        .split(" ")
        .map(w => w[0]?.toUpperCase())
        .join("");

      return (
        <>
          {/* TEXT BLOCK WITH CLAMP */}
          <div
            style={{
              position: "relative",
              ...(showFullReport
                ? {}
                : {
                    maxHeight: "7em", // ≈ 4 lines at this font size/lineHeight
                    overflow: "hidden",
                  }),
            }}
          >
            <p
              style={{
                fontSize: "15px",
                lineHeight: "1.7",
                color: "#374151",
                fontStyle: "italic",
                whiteSpace: "pre-wrap",
              }}
            >
              On {dateStr},{" "}
              <strong>{shift.staffName || "the care worker"} </strong>
              attended the scheduled visit between{" "}
              <strong>{shift.startTime}</strong> and{" "}
              <strong>{shift.endTime}</strong>. During this visit, the following
              tasks were completed: {completedSentence}. The following tasks
              remained pending after the visit: {pendingSentence}.
            </p>

            {shift.staffNotes && (
              <p
                style={{
                  marginTop: "16px",
                  fontSize: "15px",
                  lineHeight: "1.7",
                  color: "#374151",
                  whiteSpace: "pre-wrap",
                  fontStyle: "italic",
                }}
              >
                Staff noted that {shift.staffNotes}.
              </p>
            )}

            {/* STAFF INITIALS */}
            <p
              style={{
                marginTop: "16px",
                fontSize: "14px",
                color: "#475569",
                fontStyle: "italic",
              }}
            >
              Report completed by: <strong>{staffInitials}</strong>
            </p>
          </div>

          {/* MORE / LESS BUTTON */}
          <button
            type="button"
            onClick={() => setShowFullReport(prev => !prev)}
            style={{
              marginTop: "12px",
              background: "none",
              border: "none",
              color: "#2563eb",
              fontWeight: 600,
              padding: 0,
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            {showFullReport ? "Show less" : "More"}
          </button>

          {/* WHATSAPP PHOTO PROMPT */}
          <a
            href="https://wa.me/447599121308?text=Hello%20CCR,%20I%20am%20sending%20photos%20for%20my%20completed%20shift."
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "block",
              marginTop: "16px",
              backgroundColor: "#25D366",
              color: "white",
              textAlign: "center",
              padding: "12px",
              borderRadius: "12px",
              fontWeight: "600",
              textDecoration: "none",
            }}
          >
            📷 Send visit photos to CCR WhatsApp
          </a>
        </>
      );
    })()}
  </div>
)}


		
		
		
		
		
		

        {/* Directions Button */}
        {shift.clientLocation?.lat && shift.clientLocation?.lng && (
          <button
            onClick={getDirections}
            style={{
              marginTop: "14px",
              width: "100%",
              backgroundColor: "#0284c7",
              color: "white",
              padding: "10px 0",
              borderRadius: "10px",
              fontWeight: "500",
			  fontSize: "14px",
              cursor: "pointer",
            }}
          >
            Get Directions
          </button>
        )}

        {/* Contact Office */}
        <a
          href="tel:+447599121308"
          style={{
            marginTop: "12px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            alignItems: "center",
            backgroundColor: "#f9fafb",
            border: "1px solid #0284c7",
            color: "#0369a1",
            padding: "10px 0",
            borderRadius: "10px",
            fontWeight: "500",
            fontSize: "14px",
            marginBottom: "10px",
          }}
        >
          <Phone size={16} /> Call Office
        </a>
      </div>

      {/* ---------- Checklist Button ---------- */}
      {!shiftCompleted ? (
	  <Link to={`/staff/checklist/${shiftId}`}>
        <button
          style={{
            marginTop: "25px",
            width: "100%",
            maxWidth: "900px",
            marginLeft: "auto",
            marginRight: "auto",
            display: "block",
            backgroundColor: "#d946ef",
            color: "white",
            padding: "12px 0",
            borderRadius: "16px",
            fontWeight: "600",
            fontSize: "14px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          View Task Checklist
        </button>
      </Link>
	  ) : null}
	  
	  
	  
	  

      {/* ---------- Back Button ---------- */}
      <Link to="/availability">
        <button
          style={{
            marginTop: "12px",
            width: "100%",
            maxWidth: "900px",
            marginLeft: "auto",
            marginRight: "auto",
            display: "block",
            backgroundColor: "#e5e7eb",
            color: "#374151",
            padding: "12px 0",
            borderRadius: "16px",
            fontWeight: "500",
            fontSize: "14px",
          }}
        >
          Back to My Shifts
        </button>
      </Link>
    </div>
  );
}
